import { useCallback, useEffect, useState } from "react";
import {
  RECEIVE_FUNDING_FALLBACK,
  fetchReceiveFunding,
} from "@/services/receiveFundingApi";

export function useReceiveFunding() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await fetchReceiveFunding();
      setData(next);
    } catch (e) {
      if (e.name === "AbortError") return;
      setError(e.message || "Could not load receive details.");
      setData(RECEIVE_FUNDING_FALLBACK);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
